import { DXP_REGISTRATION_ROUTE } from "./constants";
import { getUserData } from "./utils";

/** Compares the email searched on step 1 with the signed-in Adobe ID email. */
export function isDxpEmailMismatchAfterIms(): boolean {
  const searchedEmail = localStorage.getItem("email")?.trim();
  if (!searchedEmail) return false;

  const imsEmail = getUserData()?.email?.trim();
  if (!imsEmail) return false;

  return searchedEmail.toLowerCase() !== imsEmail.toLowerCase();
}

/** Keeps the originally searched email for the mismatch confirmation page. */
export function preserveDxpSearchedEmailForMismatch(): void {
  const searchedEmail = localStorage.getItem("email")?.trim();
  if (searchedEmail) {
    localStorage.setItem("searchedEmail", searchedEmail);
  }
}

/** Prepares localStorage before Adobe IMS sign-in / sign-up redirects. */
export function prepareDxpImsRedirectStorage(): void {
  localStorage.removeItem("emailMismatch");
  // Do NOT remove partnerRegistrationFormStep — after IMS redirect the reducer reads it; clearing it
  // forces step 0 and shows Enter email (IMS login / new registration flow).
  localStorage.setItem("origin", "IMSPage");
  try {
    localStorage.setItem("RedirectPath", DXP_REGISTRATION_ROUTE);
  } catch {
    /* ignore */
  }
}
